<template>
  <aside class="fact-archive" aria-label="بایگانی دانستنی‌ها">
    <div class="fa-head">
      <span class="fa-icon">📚</span>
      <h2>بایگانی دانستنی‌ها</h2>
      <span class="fa-count">{{ faNo(facts.length) }} مطلب</span>
    </div>

    <p v-if="!facts.length" class="fa-empty">
      هنوز مطلبی در بایگانی نیست — با انتشار اولین دانستنی، اینجا پر می‌شود.
    </p>

    <nav v-else class="fa-list">
      <router-link
          v-for="f in facts"
          :key="f.slug"
          :to="'/did-you-know/' + f.slug"
          class="fa-item"
          :class="{ current: f.slug === currentSlug }"
      >
        <img
            v-if="f.imageUrl"
            :src="f.imageUrl"
            :alt="f.imageAlt || f.title"
            loading="lazy"
            class="fa-thumb"
        >
        <span v-else class="fa-thumb fa-thumb-ph" aria-hidden="true">💡</span>

        <span class="fa-body">
          <span class="fa-title">{{ f.title }}</span>
          <span class="fa-meta">
            <span v-if="f.category" class="fa-cat">{{ f.category }}</span>
            <span class="fa-date">{{ faDate(f.publishedAt || f.featuredAt) }}</span>
          </span>
        </span>
      </router-link>
    </nav>

    <p v-if="facts.length" class="fa-hint">
      هر روز یک دانستنی کامل با عکس و منبع اصلی منتشر می‌شود.
    </p>
  </aside>
</template>

<script>
export default {
  name: 'FactArchive',

  props: {
    // فهرست بایگانی (بدون دانستنیِ جاری) — جدیدترین اول
    facts: { type: Array, default: () => [] },
    currentSlug: { type: String, default: '' },
  },

  methods: {
    // تاریخ فارسی — «۲۳ مهر ۱۴۰۵»
    faDate(d) {
      if (!d) return ''
      try {
        return new Date(d).toLocaleDateString('fa-IR', { year: 'numeric', month: 'long', day: 'numeric' })
      } catch { return '' }
    },

    faNo(n) {
      return String(n).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[d])
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/sass/variables';
@import '@/assets/sass/mixin';

.fact-archive {
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 18px;
  padding: 18px 16px;
  box-shadow: $shadow-sm;
  position: sticky;
  top: 76px;
  max-height: calc(100vh - 96px);
  overflow-y: auto;
}

.fa-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 2px solid $gray-100;
  margin-bottom: 10px;

  .fa-icon { font-size: 20px; }

  h2 {
    margin: 0;
    font-size: 15px;
    color: #111827;
    flex: 1;
  }
}

.fa-count {
  background: $gray-50;
  border: 1px solid $gray-200;
  color: #6b7280;
  font-size: 11.5px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.fa-empty {
  margin: 6px 0;
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.9;
}

.fa-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fa-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 9px 8px;
  border-radius: 12px;
  text-decoration: none;
  transition: background .15s ease;

  &:hover { background: $gray-50; }

  // مطلب جاری — هایلایت
  &.current {
    background: linear-gradient(135deg, rgba(4, 120, 87, .08), rgba(16, 185, 129, .06));
    outline: 1px solid rgba(16, 185, 129, .25);
  }
}

.fa-thumb {
  flex-shrink: 0;
  width: 58px;
  height: 44px;
  object-fit: cover;
  border-radius: 9px;
  border: 1px solid $gray-200;

  &-ph {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 19px;
    background: linear-gradient(150deg, #064e3b, #065f46);
  }
}

.fa-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fa-title {
  color: #1f2937;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.65;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.fa-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.fa-cat {
  color: #047857;
  background: rgba(16, 185, 129, .1);
  font-size: 10.5px;
  font-weight: 700;
  padding: 1px 8px;
  border-radius: 999px;
}

.fa-date {
  color: #9ca3af;
  font-size: 11px;
}

.fa-hint {
  margin: 12px 0 0;
  padding-top: 10px;
  border-top: 1px dashed $gray-200;
  color: #9ca3af;
  font-size: 11.5px;
  line-height: 1.8;
}

@media (max-width: 768px) {
  .fact-archive {
    position: static;
    max-height: 420px;
    padding: 14px 12px;
  }
}
</style>
